import type { UserPlan } from '#src/types/user.ts';
import type { PlanPrices } from '#src/types/billing.ts';

export const PLAN_TIER: Record<UserPlan, number> = { free: 0, essential: 1, pro: 2 } as const;

export function calculateSavingsPercent(planPrices: PlanPrices | null | undefined): number | null {
	if (!planPrices?.monthly || !planPrices?.yearly) {
		return null;
	}
	const yearlyEquivalent = planPrices.monthly.amount * 12;
	if (yearlyEquivalent === 0) {
		return null;
	}
	const saving = Math.round(
		((yearlyEquivalent - planPrices.yearly.amount) / yearlyEquivalent) * 100
	);
	return saving > 0 ? saving : null;
}
